
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.248 3.781c-.906 0-1.643.73-1.643 1.633v5.777l-1.25 2.152c-.833 1.435.21 3.227 1.876 3.227h5.31c.33 0 .598-.265.598-.595a.596.596 0 00-.598-.595H4.23a.966.966 0 01-.948-.76h6.723c.33 0 .598-.265.598-.594a.597.597 0 00-.598-.595h-6.32l.862-1.486h5.177c.33 0 .598-.265.598-.595a.597.597 0 00-.598-.595H4.801v-5.34c0-.245.2-.444.447-.444h9.635c.247 0 .446.2.446.443v1.787c0 .33.269.595.598.595.33 0 .598-.265.598-.595V5.414c0-.902-.736-1.633-1.642-1.633H5.248zm11.62 5.265c-.434-1.053-1.93-1.053-2.364 0l-.506 1.228a.13.13 0 01-.137.079l-1.319-.177c-1.13-.152-1.88 1.14-1.181 2.042l.813 1.051a.128.128 0 010 .157l-.813 1.05c-.699.903.05 2.195 1.181 2.043l1.32-.177a.13.13 0 01.136.08l.506 1.227c.434 1.054 1.93 1.054 2.364 0l.505-1.228a.13.13 0 01.137-.079l1.32.177c1.13.152 1.88-1.14 1.181-2.042l-.813-1.05a.128.128 0 010-.158l.813-1.05c.699-.903-.05-2.195-1.182-2.043l-1.319.177a.13.13 0 01-.137-.079l-.505-1.228zm-1.302.436a.13.13 0 01.24 0l.505 1.228a1.28 1.28 0 001.353.779l1.318-.177a.129.129 0 01.12.206l-.813 1.05a1.272 1.272 0 000 1.559l.813 1.05a.129.129 0 01-.12.207l-1.318-.178a1.278 1.278 0 00-1.353.78l-.505 1.227a.13.13 0 01-.24 0l-.505-1.228a1.278 1.278 0 00-1.353-.779l-1.319.178a.129.129 0 01-.12-.207l.814-1.05c.355-.46.355-1.1 0-1.559l-.814-1.05a.129.129 0 01.12-.206l1.32.177a1.278 1.278 0 001.352-.78l.505-1.227zm.12 2.082c-.987 0-1.788.798-1.788 1.784 0 .985.8 1.784 1.788 1.784a1.785 1.785 0 100-3.568zm-.64 1.784a.639.639 0 111.278.002.639.639 0 01-1.278-.002z"}})])
          )
        }
      }
    